module.exports = "pegasus/assets/tech/valentine/101.png";